import React from 'react';

import { SvgPathProps } from './Icon';

const RtfFile: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path
      fillRule="evenodd"
      d="M18 15.59h12v-1H18v1zm0 4.191h12v-1H18v1zm0 4.192h12v-1H18v1zM12 39.1h23.999V8.9H12v30.2zm-1.301 1.3H37.3V7.6H10.699v32.8zm9.903-9.911c-.145.121-.38.182-.709.182h-.932v-1.526h.988c.302 0 .523.067.662.201.138.134.207.326.207.575 0 .258-.073.447-.216.568zm.976 2.026v-.4c0-.295-.057-.538-.173-.727-.117-.189-.312-.329-.59-.419.266-.111.467-.253.603-.427a1.03 1.03 0 00.203-.651c0-.457-.139-.804-.417-1.039-.277-.234-.687-.352-1.232-.352h-1.814v4.811h.803v-1.996h1.038c.248 0 .442.072.576.213.136.143.204.34.204.594v.386c0 .155.011.308.036.461a.534.534 0 00.172.342h.823v-.086a.586.586 0 01-.18-.304 1.531 1.531 0 01-.052-.406zm.522-3.37h1.5v4.166h.804v-4.166h1.502V28.5H22.1v.645zm4.507 4.166h.802v-2.052h2.095v-.644h-2.095v-1.47h2.432V28.5h-3.234v4.811z"
    />
  );

  const normalHover = (
    <path
      fillRule="evenodd"
      d="M17 15.59h14.001v-1H17v1zm0 4.191h14.001v-1H17v1zm0 4.192h14.001v-1H17v1zM12 39.1h23.999V8.9H12v30.2zm-1.301 1.3H37.3V7.6H10.699v32.8zm9.903-9.911c-.145.121-.38.182-.708.182h-.932v-1.526h.987c.302 0 .523.067.661.201.139.134.208.326.208.575 0 .258-.072.447-.216.568zm.976 2.026v-.4c0-.295-.057-.538-.173-.727-.116-.189-.312-.329-.59-.419.266-.111.467-.253.603-.427.136-.174.203-.391.203-.651 0-.457-.139-.804-.416-1.039-.277-.234-.688-.352-1.232-.352h-1.815v4.811h.804v-1.996h1.037c.249 0 .441.072.576.213.136.143.203.34.203.594v.386c0 .155.013.308.037.461a.53.53 0 00.172.342h.823v-.086a.586.586 0 01-.18-.304 1.531 1.531 0 01-.052-.406zm.523-3.37h1.5v4.166h.802v-4.166h1.503V28.5h-3.805v.645zm4.505 4.166h.803v-2.052h2.095v-.644h-2.095v-1.47h2.433V28.5h-3.236v4.811z"
    />
  );

  return isHovered ? normalHover : normal;
};

export default RtfFile;
